var map = {
  "./api_requests": "10250",
  "./api_requests.js": "10250",
  "./integration_licenses_tab": "79393",
  "./integration_licenses_tab.js": "79393",
  "./tabs": "91413",
  "./tabs.js": "91413"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 35659;
